import React from 'react';
import { siteConfig } from '../data/siteConfig';
export function SiteFooter() {
  return <footer className="bg-navy py-8" data-id="element-155" data-mp="3r7pvtsx9m72x">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-5 text-sm text-white/70 sm:flex-row" data-id="element-156" data-mp="3r8rk4z3akq2l">
        <p data-id="element-157" data-mp="3mf6jezabdhzp">© 2026 {siteConfig.productName}. Digital products only.</p>
        <nav aria-label="Footer" className="flex gap-5" data-id="element-158" data-mp="3hhwtlij0j4bc">
          <a href={siteConfig.refundPolicyUrl} className="hover:text-white" data-id="element-159" data-mp="3dhe25pl1809o">
            Refund policy
          </a>
          <a href={`mailto:${siteConfig.supportEmail}`} className="hover:text-white" data-id="element-160" data-mp="38gqbj50ptlfz">
            Contact support
          </a>
        </nav>
      </div>
    </footer>;
}